export { getCurrentNews } from "./getCurrentNews";
export { getNewsPage } from "./getNewsPage";
